﻿<div class="card card-default rdo-card rdo-card-default" [ngClass]="{'rdo-card-bench' : isBenchmarkMode(), 'rdo-card-book': !isBenchmarkMode()}">
  <div [class.hidden]="!loading" class="ovrl">
  </div>
  <div class="card-header">
    <div class="card-title multi-top-list-title">
      @for (cgf of _configs; track cgf; let i = $index) {
        <a class="link multi-top-list-link" (click)="switchTo(i)" id="{{cgf.title | rdoPathToId}}"
        [ngClass]="{selected:i===selectedIndex}">{{cgf.title | translate}}</a> &nbsp;&nbsp;&nbsp;
      }
    </div>
  </div>
  <table class="table table-nowrap">
    <tbody>
      <tr>
        <th></th>
        @if (isBenchmarkMode()) {
          <th id="{{'main.tabs.summary.tables.client_compared' | rdoPathToId}}" class="rdo-table-title rdo-narrow-title"><div
          >{{'main.tabs.summary.tables.client_compared_revenue' | translate}}</div></th>
          <th id="{{'main.tabs.summary.tables.client_rate_vs.1' | rdoPathToId}}" class="rdo-table-title rdo-wide-title"><div
          >{{'main.tabs.summary.tables.client_rate_vs_benchmark' | translate}}</div></th>
        }
        @if (!isBenchmarkMode()) {
          <th id="{{'main.tabs.summary.tables.client_total' | rdoPathToId}}" class="rdo-table-title rdo-narrow-title"><div
          >{{'main.tabs.summary.tables.client_total_revenue' | translate}}</div></th>
          <th id="{{'main.tabs.summary.tables.client_rate_vs.2' | rdoPathToId}}" class="rdo-table-title rdo-wide-title"><div
          >{{'main.tabs.summary.tables.client_rate_vs_book' | translate}}</div></th>
        }
      </tr>
      @for (i of items; track i) {
        <tr>
          <td>
            <span [title]="i.Name">
              @if (i.LinkDsl) {
                <a [routerLink]="i.LinkDsl">
                  {{i.Name}}
                </a>
              }
              @if (!i.LinkDsl) {
                <span>
                  {{i.Name}}
                </span>
              }
            </span>
          </td>
          @if (isBenchmarkMode()) {
            <td [ngClass]="{'text-muted':i.ClientBenchmarkedRevenue === 0}">
              {{i.ClientBenchmarkedRevenue | rdoCurrency:true}}
            </td>
            <td>
              <rdo-amount-difference [clientValue]="i.ClientBenchmarkedRevenue" [benchmarkedValue]="i.BenchmarkedRevenue"></rdo-amount-difference>
            </td>
          }
          @if (!isBenchmarkMode()) {
            <td [ngClass]="{'text-muted':i.RevenueTotal === 0}">
              {{i.RevenueTotal | rdoCurrency:true}}
            </td>
            <td>
              <rdo-amount-difference [clientValue]="i.RevenueTotal" [benchmarkedValue]="i.RevenueBook"></rdo-amount-difference>
            </td>
          }
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <td colspan="3">
          @if (selectedConfig?.footerLinkDsl) {
            <a [routerLink]="selectedConfig.footerLinkDsl"
              id="{{(getFooterLinkTitle(selectedConfig.footerLinkTitle)) | rdoPathToId}}"
              >{{getFooterLinkTitle(selectedConfig.footerLinkTitle)}}<i class="fa fa-fw fa-angle-double-right"></i></a>
            }
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
